import type { MenuProps } from "antd";
import type { NavigateFunction } from "react-router-dom";
import { IdcardOutlined, LogoutOutlined, SafetyCertificateOutlined, ShoppingOutlined } from "@ant-design/icons";
import { globalModel } from "../../global/GlobalModel";

export function standaloneTactikUserMenu(opts: {
  navigate: NavigateFunction;
}): MenuProps {
  const { navigate } = opts;
  return {
    items: [
      { key: "profile", label: "个人资料", icon: <IdcardOutlined /> },
      { key: "orders", label: "我的订单", icon: <ShoppingOutlined /> },
      { key: "benefits", label: "我的权益", icon: <SafetyCertificateOutlined /> },
      {
        key: "logout",
        label: "退出登录",
        icon: <LogoutOutlined />,
      },
    ],
    onClick: ({ key }) => {
      if (key === "profile") {
        navigate("/tactik/profile");
        return;
      }
      if (key === "orders") {
        navigate("/tactik/orders");
        return;
      }
      if (key === "benefits") {
        navigate("/tactik/benefits");
        return;
      }
      if (key === "logout") {
        void globalModel.logout();
      }
    },
  };
}
